import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Globe, MapPin } from 'lucide-react';
import { useLanguage, Language } from './LanguageContext';
export function LanguageSwitcher() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const languages: {
    code: Language;
    label: string;
  }[] = [{
    code: 'en',
    label: 'English'
  }, {
    code: 'es',
    label: 'Español'
  }, {
    code: 'he',
    label: 'עברית'
  }];
  return <div className="fixed top-6 right-6 z-50 flex items-center gap-3" data-id="element-76">
      <a href="https://www.google.com/maps/search/?api=1&query=1720+Harrison+St+5th+Floor+Hollywood+FL" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-12 h-12 rounded-full bg-studio-black border border-studio-gold/30 text-studio-gold hover:bg-studio-gold/10 hover:border-studio-gold transition-all duration-300 shadow-lg" aria-label="Get directions" data-id="element-77">
        <MapPin className="w-5 h-5" data-id="element-78" />
      </a>
      <a href="https://www.instagram.com/nikkis_hairdressing_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-12 h-12 rounded-full bg-studio-black border border-studio-gold/30 hover:bg-studio-gold/10 hover:border-studio-gold transition-all duration-300 shadow-lg" aria-label="Follow us on Instagram" data-id="element-79">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-80">
          <defs data-id="element-81">
            <radialGradient id="ig-gradient-nav" cx="30%" cy="107%" r="150%" data-id="element-82">
              <stop offset="0%" stopColor="#fdf497" data-id="element-83" />
              <stop offset="5%" stopColor="#fdf497" data-id="element-84" />
              <stop offset="45%" stopColor="#fd5949" data-id="element-85" />
              <stop offset="60%" stopColor="#d6249f" data-id="element-86" />
              <stop offset="90%" stopColor="#285AEB" data-id="element-87" />
            </radialGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#ig-gradient-nav)" strokeWidth="2" fill="none" data-id="element-88" />
          <circle cx="12" cy="12" r="4.5" stroke="url(#ig-gradient-nav)" strokeWidth="2" fill="none" data-id="element-89" />
          <circle cx="17.5" cy="6.5" r="1.25" fill="url(#ig-gradient-nav)" data-id="element-90" />
        </svg>
      </a>
      <div className="relative" data-id="element-91">
        <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-4 h-12 rounded-full bg-studio-black border border-studio-gold/30 text-studio-gold hover:bg-studio-gold/10 hover:border-studio-gold transition-all duration-300 shadow-lg" aria-label="Change language" data-id="element-92">
          <Globe className="w-5 h-5 shrink-0" data-id="element-93" />
          <span className="text-sm font-inter tracking-wide" data-id="element-94">Languages</span>
        </button>

        <AnimatePresence data-id="element-95">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} className="absolute right-0 mt-3 w-36 bg-studio-black border border-studio-gold/30 shadow-2xl overflow-hidden" data-id="element-96">
              {languages.map(lang => <button key={lang.code} onClick={() => {
            setLanguage(lang.code);
            setIsOpen(false);
          }} className={`w-full text-left px-4 py-3 text-sm font-inter transition-colors duration-200 ${language === lang.code ? 'bg-studio-gold/20 text-studio-gold font-medium' : 'text-gray-300 hover:bg-white/5 hover:text-white'}`} dir={lang.code === 'he' ? 'rtl' : 'ltr'} data-id="element-97">
                  {lang.label}
                </button>)}
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}